import type { Component } from "solid-js";
import type { IconProps } from "./types";

const IntegrationIcon: Component<IconProps> = (props) => {
  const size = props.size || 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path d="M3.75 3A1.75 1.75 0 002 4.75v3.5c0 .966.784 1.75 1.75 1.75h3.5A1.75 1.75 0 009 8.25v-3.5A1.75 1.75 0 007.25 3h-3.5zM3.75 11A1.75 1.75 0 002 12.75v3.5c0 .966.784 1.75 1.75 1.75h3.5A1.75 1.75 0 009 16.25v-3.5A1.75 1.75 0 007.25 11h-3.5zM11.75 3a1.75 1.75 0 00-1.75 1.75v3.5c0 .966.784 1.75 1.75 1.75h3.5A1.75 1.75 0 0017 8.25v-3.5A1.75 1.75 0 0015.25 3h-3.5z" />
      <path d="M11.75 11a1.75 1.75 0 00-1.75 1.75v3.5c0 .966.784 1.75 1.75 1.75h3.5A1.75 1.75 0 0017 16.25v-3.5A1.75 1.75 0 0015.25 11h-3.5z" />
      <path
        d="M6.5 6.5h7M13.5 13.5h-7M13.5 6.5v7"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        fill="none"
      />
    </svg>
  );
};

export default IntegrationIcon;
